import { ButtonProps, FabButton } from 'components/uikit/buttons/FabButton.tsx';
import { ProjectPermissionProps } from '../types/projectPermission.ts';
import { PermissionGate } from '../PermissionGate.tsx';

export const PermissionFabButton = (
  props: ButtonProps & ProjectPermissionProps,
) => {
  return (
    <PermissionGate {...props}>
      <FabButton {...props} />
    </PermissionGate>
  );
};
